import InputBase from '@material-ui/core/InputBase';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import React from 'react';
import SearchIcon from '@material-ui/icons/Search';
import { withStyles } from '@material-ui/core/styles';
import KeyboardEventHandler from 'react-keyboard-event-handler';
import { styles } from './SearchBar.styles';
import IconButton from '../IconButton';

const SearchBar = props => {
  const { classes } = props;
  return (
    <KeyboardEventHandler handleKeys={['enter']} onKeyEvent={() => props.onClick()}>
      <Paper className={classes.root} style={props.style} elevation={1}>
        <InputBase
          className={classes.input}
          placeholder={props.label || 'Rechercher un client'}
          value={props.value}
          onBlur={props.onBlur}
          onChange={props.onChange}
        />
        <IconButton className={classes.iconButton} label='Search'>
          <SearchIcon onClick={props.onClick} />
        </IconButton>
      </Paper>
    </KeyboardEventHandler>
  );
};

SearchBar.propTypes = {
  classes: PropTypes.element.isRequired
};

export default withStyles(styles)(SearchBar);
